// node modules
import { gql } from '@apollo/client';

// app modules: constants
import {
  USER_COLLECTION_UPDATE_START,
  USER_COLLECTION_UPDATE_SUCCESS,
  USER_COLLECTION_UPDATE_ERROR,
} from 'constants/index';

import CollectionFields from './CollectionFields.graphql';

const MUTATION = {
  UPDATE_COLLECTION: gql`
    mutation UpdateCollection($id: Int, $input: UpdateCollectionInput!) {
      UpdateCollection(id: $id, input: $input) {
        ...CollectionFields
      }
    }
    ${CollectionFields}
  `,
};

function handleError({ id, input, dispatch }) {
  dispatch({
    type: USER_COLLECTION_UPDATE_ERROR,
    payload: {
      id,
      input,
    },
  });
}

function handleSuccess({ id, input, dispatch, data }) {
  dispatch({
    type: USER_COLLECTION_UPDATE_SUCCESS,
    payload: {
      id,
      input,
      ...data.UpdateCollection,
    },
  });
}

/**
 * @param {Number} id
 * @param {Object} input
 * @param {String} [input.name]
 * @param {String} [input.description]
 * @param {Array.<String>} [input.books]
 * @param {Array.<String>} [input.contents]
 * @param {Array.<String>} [input.people]
 */
export default function updateCollection(id, input) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: USER_COLLECTION_UPDATE_START,
      payload: {
        id,
        ...input,
      },
    });

    try {
      const cachedCollection = client.readFragment({
        id: `Collection:${id}`,
        fragment: CollectionFields,
      });

      const optimisticResponse = {
        UpdateCollection: {
          __typename: 'Collection',
          id,
          ...cachedCollection,
          ...input,
        },
      };
      const { data, errors } = await client.mutate({
        mutation: MUTATION.UPDATE_COLLECTION,
        variables: {
          id,
          input: {
            name: input.name,
            description: input.description,
            books: input.books,
            contents: input.contents,
            people: input.people,
            visibility: input.visibility,
            custom_cover_image: input.custom_cover_image,
            custom_hero_image: input.custom_hero_image,
            tags: input.tags,
          },
        },
        optimisticResponse,
      });

      if (errors && errors.length > 0) {
        handleError({ dispatch, errors: errors[0].graphQLErrors });
        return { error: errors[0].graphQLErrors };
      }
      handleSuccess({ id, input, dispatch, data });
      return { data: data.UpdateCollection };
    } catch (error) {
      handleError({ id, input, dispatch, errors: error.graphQLErrors });
      return { error };
    }
  };
}
